import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { NgForm, ValidatorFn, AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { PasswordValidationService } from '../../../../shared/services/password-validation.service';

@Component({
    selector: 're-sng-legacy-import-confirmation-dialog',
    templateUrl: './sng-legacy-import-confirmation-dialog.component.html',
    styleUrls: ['./sng-legacy-import-confirmation-dialog.component.scss'],
    standalone: false
})
export class SngLegacyImportConfirmationDialogComponent implements OnInit{

  constructor(private activeModal: NgbActiveModal, private router: Router, private passwordValidationSvc: PasswordValidationService) { }


  passwordValidator(control: AbstractControl): ValidationErrors | null {
    this.valueChange(control.value);
    var valid = this.passwordValidationSvc.validatePassword(this.tempPassword, null, null, null, null, false, false, true).isValid();
    if (!valid)
      return { invalidPassword: true };

    return null;
  }

  ngOnInit(): void {
    setTimeout(() => {
      var tempPasswordControl = this.form.controls.tempPassword;
      tempPasswordControl.setValidators([ Validators.required, (control) => this.passwordValidator(control) ]);
    });
  }

  domainRegExPattern = /@(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/i;
  domain: string;
  crmID: string;
  tempPassword: string;


  @ViewChild("form")
  form: NgForm;

  valueChange(value=null) {
    //if (!value)
    //  value = this.tempPassword;
    //this.lowerCase = this.reLowerCase.test(value);
    //this.upperCase = this.reUpperCase.test(value);
    //this.numberCase = this.reNumberCase.test(value);
    //this.specialCharacterCase = this.reSpecialCharacterCase.test(value);
    //this.minLengthCase = this.reMinLengthCase.test(value);
  }

  

  numberOfUsers = 0;
  accept() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}
